import { AppAction } from '../../config/appConfig'
import { useDispatch } from 'react-redux'
import IdentityContext, { Identity, IdentityContextProps } from '../../context/IdentityContext'
import { useContext } from 'react'

export default function useLogOut(): (type?: AppAction.Reset) => void {
    const dispatch = useDispatch()
    const { username } = useContext<IdentityContextProps>(IdentityContext)

    return (type?: AppAction.Reset | AppAction.LogOut) => {
        dispatch({ type: type || AppAction.LogOut })
        Identity.current.logout(AppAction.LogOut, username, false)

        if (type === AppAction.Reset) {
            window.location.reload()
        }
    }
}
